/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Preparing_LabelInputs */

const en_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing secure sign-in…`)
};

const de_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichere Anmeldung wird vorbereitet…`)
};

const pt_br2_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando o acesso seguro…`)
};

const tr_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenli giriş hazırlanıyor…`)
};

const zh_cn2_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在准备安全登录…`)
};

const zh_hk2_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在準備安全登入…`)
};

const ko_kr2_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전한 로그인 준비 중…`)
};

const ru_ru2_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготавливаем безопасный вход…`)
};

const es_419_login_page_preparing_label = /** @type {(inputs: Login_Page_Preparing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando el inicio de sesión seguro…`)
};

/**
* | output |
* | --- |
* | "Preparing secure sign-in…" |
*
* @param {Login_Page_Preparing_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_preparing_label = /** @type {((inputs?: Login_Page_Preparing_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Preparing_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_preparing_label(inputs)
	if (locale === "de") return de_login_page_preparing_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_preparing_label(inputs)
	if (locale === "tr") return tr_login_page_preparing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_preparing_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_preparing_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_preparing_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_preparing_label(inputs)
	return es_419_login_page_preparing_label(inputs)
});